import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import { closeAllModals } from 'modal/store/actions';
import { Routes } from 'react-router-dom';
import Offline from '../Offline';
import OfflineAppMain from '../OfflineAppMain';

/**
 * Offline App main container
 *
 * Note: when going offline, all open modals are closed in order to solve BI-258.
 * This way, we avoid having the online file viewer open in offline mode,
 * which would lead to loss of annotations.
 */
const OfflineApp = ({ closeAllModals }) => (
  <Offline onChange={closeAllModals}>
    <Routes>
      <Route component={OfflineAppMain} />
    </Routes>
  </Offline>
);
OfflineApp.propTypes = {
  closeAllModals: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  closeAllModals,
};

export default connect(null, mapDispatchToProps)(OfflineApp);
